module.exports = __webpack_public_path__ + "img/htf4.9d5a82e1.jpg";